import stepLabelClasses from "@mui/material/StepLabel/stepLabelClasses";
export const MuiStepButtonTheme = (dt) => {
    return {
        defaultProps: {
            disableRipple: true,
        },
        styleOverrides: {
            root: {
                position: "static",
                boxSizing: "border-box",
                justifyContent: "flex-start",
                margin: 0,
                padding: 0,
                textAlign: "left",
                [`&:where(:hover, :focus-visible) .${stepLabelClasses.label}[class][class][class]`]: {
                    color: dt.color.palette.primary[50],
                    textDecoration: "underline",
                },
            },
        },
    };
};
